import {
    THIRD_PARTY_MAPPED_ACCOUNT,
} from '../../constants/actionType';

export const thirdPartyAccountAction = ({ thirdPartyAccount }) => async dispatch => {
    try {
        dispatch({
            type: THIRD_PARTY_MAPPED_ACCOUNT,
            thirdPartyAccount
        });
    } catch (err) {
    } finally {

    }
};
